import React, { FunctionComponent } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { PostSnippet } from "../../types";
import { PostMeta } from "../postMeta";

export interface PostCard extends PostSnippet {
  /** Related-posts variant: no topic label or summary, 24px title. */
  compact?: boolean;
}

export const PostCard: FunctionComponent<PostCard> = ({
  title,
  summary,
  href,
  img,
  imgAlt,
  topic,
  type,
  readingTime,
  compact,
}) => (
  <Link
    to={href}
    className={`group flex flex-col ${compact ? "gap-3" : "gap-3.5"}`}
  >
    <div className="aspect-[4/3] border-2 border-ink transition duration-maker ease-maker group-hover:-translate-x-0.5 group-hover:-translate-y-0.5 group-hover:shadow-hard">
      <Image fluid={img} alt={imgAlt || title} style={{ height: "100%" }} />
    </div>
    <PostMeta
      topic={compact ? undefined : topic}
      type={type}
      readingTime={readingTime}
    />
    <h3
      className={`font-display font-semibold transition-colors duration-maker ease-maker group-hover:text-spark ${
        compact ? "text-2xl leading-[1.1] tracking-[-0.01em]" : "text-h3"
      }`}
    >
      {title}
    </h3>
    {!compact && (
      <p className="line-clamp-2 text-body-sm text-body-2">{summary}</p>
    )}
  </Link>
);

export interface PostGrid {
  posts: PostSnippet[];
  compact?: boolean;
}

export const PostGrid: FunctionComponent<PostGrid> = ({ posts, compact }) => (
  <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
    {posts.map((post) => (
      <PostCard {...post} compact={compact} key={post.href} />
    ))}
  </div>
);
